
		<div
			class="form-group"
			[formGroup]="OBJ_form_group"
			[ngClass]="{'has-error': isInvalid()}">
			<label class="col-lg-2 control-label" [ngClass]="{'tgi-new': isNew()}">{{getLabelName()|translate}}
				<span *ngIf="isRequired()" class="tgi-asterisk"> *</span></label>
			<div class="col-lg-8">
				<input
					class="form-control"
					[formControlName]="OBJ_field_config.name"
					[placeholder]="getLabelName()|translate"
					[owlDateTimeTrigger]="dt"
					[owlDateTime]="dt"
					[selectMode]="OBJ_field_config?.selectMode?OBJ_field_config.selectMode:'single'"
					(dateTimeChange)="dateTimeChange($event)"
				> <i
				class="fa fa-calendar tig-calendar"
				[owlDateTimeTrigger]="dt"
				[disabled]="OBJ_field_config?.readonly"></i>
				<owl-date-time
					#dt
					[pickerType]="OBJ_field_config?.datepicker_type?OBJ_field_config?.datepicker_type:'both'"
					[stepMinute]="OBJ_field_config?.steps?.minute?OBJ_field_config?.steps?.minute:1"
					[stepHour]="OBJ_field_config?.steps?.hour?OBJ_field_config?.steps?.hour:1"
					[stepSecond]="OBJ_field_config?.steps?.second?OBJ_field_config?.steps?.second:1"
					[startAt]=startAt
				></owl-date-time>
				<div class="tig-hint" *ngIf="OBJ_field_config.note">
					<span>{{ OBJ_field_config.note|translate}}</span>
				</div>
				<tig-form-error [OBJ_form_control]="OBJ_form_group.get(OBJ_field_config.name)"></tig-form-error>
			</div>
		</div>
	